import { combineReducers } from 'redux';
import screen from './screenReducer';
import ajaxCallsInProgress from './ajaxStatusReducer';
import loginReducer from './loginReducer';
import { messageReducer } from './messageReducer';
import privateAlbums from './privateAlbumReducer';
import privateAlbumAdvanceReducer from './privateAlbumReducerAdvance';
import rosterReducer from './rosterReducer';
import iceBreakers from './iceBreakerReducer';
import quickMessages from './quickMessageReducer';
import quickMessageReducerAdvance from './quickMessageReducerAdvance';
import commonReducer from './commonReducer';
import subscribeReducer from './subscribeReducer';
import conversationsReducer from './conversationReducer';
import friendsAndFavoritesReducer from './friendsAndFavoritesReducer';
import chatStateReducer from './chatStateReducer';
import userRegister from './registerReducer';
import navigationReducer from './navigationReducer';
import appStateReducer from './appStateReducer';
import usersReducer from './usersReducer';
import reportPopupReducer from './reportPopupReducer';
import memberSearchReducer from './memberSearchReducer';
import memberViewProfilesReducer from './memberViewProfilesReducer';
import memberProfileReducer from './memberProfileReducer';
import toggleNoProfilePhotoReducer from './toggleNoProfilePhotoReducer';
import videoCallReducer from './videoCallReducer';
import memberProspectsReducer from './memberProspectsReducer';
import commonStateReducer from './commonStateReducer';
import groupChatReducer from './groupsChatReducer';
import liveStreamReducer from './liveStreamReducer';
import newFeedReducer from './newFeedReducer';
import notificationReducer from './notificationReducer';
import eventReducer from './eventReducer';
import memberTypePluralReducer from './memberTypePluralReducer';
import userSearchSettingReducer from './userSearchSettingReducer';
import publicLiveStreamsReducer from './publicLiveStreamsReducer';
import messageSummaryReducer from './messageSummaryReducer';
import screenSummaryReducer from './screenSummaryReducer';
import foldersReducer from './foldersReducer';
import initialState from './initialState';
import notificationSummaryReducer from './notificationSummaryReducer';
import * as types from '../constants/actionTypes';
import editProfileReducer from './editProfileReducer';
import validationReducer from './validationReducer';
import blockListReducer from './blockListReducer';
import privateAlbumsAccessReducer from './privateAlbumAccessReducer';
import hiddenListReducer from './hiddenListReducer';
import paymentGatewayReducer from './paymentGatewayReducer';
import dateFinderReducer from './dateFinderReducer';
import travelPlanReducer from './travelPlanReducer';
import forumReducer from './forumReducer';
import communityReducer from './communityReducer';
import supportTicketReducer from './supportTicketReducer';
import rhpStoreReducer from './rhpStoreReducer';
import giftReducer from './giftReducer';
import recentlyValidatedReducer from './recentlyValidatedReducer';
import sharedMediaReducer from './sharedMediaReducer';
import consumableReducer from './consumableReducer';
import groupReducer from './groupReducer';
import inviteCreditReducer from './InviteCreditReducer';
import reportReducer from './reportReducer';
import { RootState } from 'redhotpie-shared-lib/hooks/useRedux';

const appReducer = combineReducers({
  foldersReducer,
  giftReducer,
  publicLiveStreamsReducer,
  userSearchSettingReducer,
  memberTypePluralReducer,
  ajaxCallsInProgress,
  loginReducer,
  screen,
  privateAlbums,
  privateAlbumAdvanceReducer,
  iceBreakers,
  quickMessages,
  quickMessageReducerAdvance,
  messageReducer,
  conversationsReducer,
  rosterReducer,
  commonReducer,
  subscribeReducer,
  friendsAndFavoritesReducer,
  chatStateReducer,
  userRegister,
  navigationReducer,
  appStateReducer,
  usersReducer,
  reportPopupReducer,
  memberSearchReducer,
  memberViewProfilesReducer,
  memberProfileReducer,
  toggleNoProfilePhotoReducer,
  videoCallReducer,
  memberProspectsReducer,
  commonStateReducer,
  liveStreamReducer,
  groupChatReducer,
  newFeedReducer,
  notificationReducer,
  eventReducer,
  groupReducer,
  messageSummaryReducer,
  screenSummaryReducer,
  notificationSummaryReducer,
  editProfileReducer,
  validationReducer,
  hiddenListReducer,
  privateAlbumsAccessReducer,
  blockListReducer,
  paymentGatewayReducer,
  dateFinderReducer,
  travelPlanReducer,
  forumReducer,
  communityReducer,
  supportTicketReducer,
  rhpStoreReducer,
  recentlyValidatedReducer,
  sharedMediaReducer,
  consumableReducer,
  inviteCreditReducer,
  reportReducer,
});
let defaultState = null;
const rootReducer = (state: any, action: any) => {
  if (action.type === 'LOAD_APP') {
    defaultState = initialState;
  }
  if (action.type === types.USER_LOGOUT_SUCCESS) {
    //  console.log("User logout success");
    // state.loginReducer = defaultState.login
    // state.memberSearchReducer = state.memberSearch
  }

  return appReducer(state, action);
};
export default rootReducer;
